export default "__VITE_ASSET__CPmVQYDm__"